import { useState} from 'react';
import { Text } from "@react-three/drei";
import * as THREE from "three";

export default function GlowingText({ size, position, color, isMain, onClick }) {
  const [hovered, setHovered] = useState(false);

  const handlePointerOver = () => {
    if (!isMain) setHovered(true);
  };

  const handlePointerOut = () => {
    if (!isMain) setHovered(false);
  };

  const adjustedScale = hovered ? (size * 1.055) : size;

  return (
    <>
      <Text fontSize={adjustedScale} fontWeight={700} height={0.1} position={position} color="#ff4500" onClick={onClick} onPointerOver={handlePointerOver} onPointerOut={handlePointerOut}>
        CS
      </Text>
    </>
  );
}